<template>
  <div>
    <div class="list-item-icon">
      <b-icon
        icon="horseshoe">
      </b-icon>
    </div>
    <div class="list-item-content">
      <p>
        <strong>{{horse.name}}</strong>
        <br>
        Caballo
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    horse: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
  }
}
</script>
